var _circle, _line, _circle2, _path, _path2, _path3, _ellipse, _ellipse2, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 79,
    r: 35,
    stroke: "#404756",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77.1796,
    y1: 45.0801,
    x2: 77.1796,
    y2: 68.4306,
    stroke: "#46AFB1",
    strokeWidth: 5.00369
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.9994,
    cy: 102.999,
    r: 16.9994,
    fill: "#46AFB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 88C46.6883 93.6665 50.4647 104.813 34.5 112.5M57 92.5C60.2028 98.9056 64.1472 109.131 47 118",
    stroke: "#90D4D9",
    strokeWidth: 3.77765
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6179 34C67.4014 34.278 81.8009 38.8369 77.1308 54.8487C68.5134 56.7946 52.9463 55.3491 59.6179 34Z",
    fill: "#7CBCD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7708 34C86.9872 34.278 72.5877 38.8369 77.2579 54.8487C85.8753 56.7946 101.442 55.3491 94.7708 34Z",
    fill: "#7CBCD3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.0435,
    cy: 113.305,
    rx: 5.04348,
    ry: 2.52174,
    fill: "#46AFB1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.956,
    cy: 107,
    rx: 5.04348,
    ry: 2.52174,
    fill: "#46AFB1"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 102.088,
    y1: 114.564,
    x2: 102.088,
    y2: 86.8253,
    stroke: "#46AFB1",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 105.738,
    x2: 120,
    y2: 77.9992,
    stroke: "#46AFB1",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 120.887,
    y1: 78.7924,
    x2: 100.887,
    y2: 88.6927,
    stroke: "#46AFB1",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClo3);
export default __webpack_public_path__ + "static/media/clo-3.04d97a449f0e6762ba99a57af61e220b.svg";
export { ForwardRef as ReactComponent };